import { SWRResponse } from 'swr';

export type LoadingState = 'error' | 'loaded' | 'loading';

export const getSwrLoadingState = <TData, TError>(
    response: SWRResponse<TData, TError>
): LoadingState => {
    if (response.error) {
        return 'error';
    }
    if (response.data) {
        return 'loaded';
    }
    return 'loading';
};
